<template>
  <!-- 城市-服务费-城市服务费 -->
  <div>

    <div class="card-wrap">
      <el-card style="width: 55%;background: #F2FBFF;">
        <div class="title-top">
          <h4>当前可用余额（元）</h4>
          <div>
            <p>开城日期：{{ city_date }}</p>
            <p>城市状态：<span :class="{'green':total_money >= 0}">{{total_money >= 0?'服务中':'暂停服务'}}</span></p>
          </div>
        </div>
        <div class="main">
            <div></div>
          <p>{{ total_money }}</p>
          <div class="btn" @click="rechargeBtn">充值</div>
        </div>

        <div
        v-for="(item, index) in total_money_annualFee"
        :key="index"
        class="text-annualFee"
      >
        <!-- 未开启订单服务费第一条不显示，未开启年费的第二条不显示 -->

        <div
          style="display: inline-block;"
          v-if="total_money_annualFee.length > 1"
        >{{ index + 1 }}:</div>
        {{ item }}
      </div>

        <div class="bottom">
          <p>预警金额（元）
            <el-popover
              placement="top-start"
              title=""
              width="600"
              trigger="hover"
              content="城市未开启订单服务费，预警金额默认为服务费金额，余额不足，扣款日当月弹窗提示，已开启订单服务费的自行配置，扣款日当月预警值变为服务费金额，余额不足弹窗提示"
            >
              <i
                slot="reference"
                class="el-icon-question"
                style="color: #333; margin-left: 10px"
              ></i>
            </el-popover>
          </p>
          <p>{{ alert_num }}</p>
          <!--
            :class="{'disabled':is_alert_month == 1}"
            :disabled="is_alert_month == 1"
          -->
          <div
            class="btn"
            @click="btnClick"
          >
            设置
          </div>
        </div>
      </el-card>
      <div style="width: 44%;">
        <el-card style="padding-bottom: 60px;">
            <div class="title-top">总充值余额（元）</div>
            <div class="main" style="justify-content: center;">
                <p style="font-size: 36px;">{{ amount }}</p>
            </div>
        </el-card>
        <el-card style="margin-top: 10px;padding-bottom: 60px;">
            <div class="title-top">已扣费余额（元）</div>
            <div class="main" style="justify-content: center;">
                <p style="font-size: 36px;">{{ used_amount }}</p>
            </div>
        </el-card>
      </div>
    </div>


    <div class="container">
      <div class="handle-box-search1">
        <div class="handle-box">
          <div style="font-size: 20px; font-weight: 700; margin-bottom: 20px;color:#606266">城市服务费记录列表</div>
          <el-row class="head-search">
            <el-col
              :span="24"
              style="margin-top: 10px"
            >
              <span class="title">查询时间:</span>

              <el-date-picker
                v-model="search_time"
                type="datetimerange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="timeChange"
                style="width: 350px"
              >
              </el-date-picker>
            </el-col>
          </el-row>
        </div>

        <el-button
          type="primary"
          icon="el-icon-search"
          @click="searchServiceFeeLogLists"
        >搜索</el-button>
        <el-button
          icon="el-icon-refresh-right"
          @click="refresh"
        >刷新</el-button>

        <el-button
          :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'"
          @click="toExport"
          :disabled="progress_show"
        >{{
                    progress_show ? '导出中...' : '导出'
                }}</el-button>

        <!-- 导出进度条 -->
        <div
          style="width: 500px; margin: 10px auto"
          v-if="progress_show"
        >
          <el-progress :percentage="progress_data"></el-progress>
          <i class="el-icon-loading"></i>
          正在导出...
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        style="margin-top: 20px"
        :data="tableData"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        > </el-table-column>
        <el-table-column
          prop="city.name"
          label="城市名称"
        > </el-table-column>
        <el-table-column
          prop="billno"
          label="订单编号"
        > </el-table-column>

        <el-table-column
          prop="time.YmdHis"
          label="时间"
        > </el-table-column>

        <el-table-column
          prop="mode.alias"
          label="模式"
        > </el-table-column>

        <el-table-column
          prop="amount"
          label="金额"
        > </el-table-column>
        <el-table-column
          prop="description"
          label="说明"
        > </el-table-column>
        <el-table-column
          prop="type"
          label="类型"
        > </el-table-column>
      </el-table>

      <!-- element ui 原生分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search_data.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search_data.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="result_data.count"
        >
        </el-pagination>
      </div>
      <!-- 充值二维码组件 -->
      <recharge
        :isShow="recharge_isShow"
        @onSubmit="onSubmit"
      ></recharge>

      <!-- 预警值设置组件 -->
      <editAlertNumSubmit
        :isShow="edit_isShow"
        :data="alert_num"
        @onSubmit="onSubmit"
      > </editAlertNumSubmit>
    </div>
  </div>
</template>

<script>
let _this;
import editAlertNumSubmit from './editAlertNumSubmit.vue';
import recharge from './recharge.vue';

export default {
    components: {
        editAlertNumSubmit,
        recharge
    },
    data() {
        return {
            is_alert_month: '',

            alert_num: '',
            total_money: '',
            city_date: '',
            status: '',
            total_money_annualFee: '',
            fee_count_log_code: '',
            search_time: '',
            excelData: [],
            progress_show: false,
            progress_data: 0,
            edit_isShow: false,
            recharge_isShow: false,
            amount: '',
            used_amount: '',

            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                fixed_time: '',
                fee_count_log_code_array: ''
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },
            result_data: []
        };
    },
    created() {
        _this = this;

        _this.searchServiceFeeLogLists();

        _this.serviceFeeLists(); //获取账户信息
    },
    methods: {
        btnClick(){
            // if(this.is_alert_month == 1){
            //     return
            // }
            this.edit_isShow = !this.edit_isShow
        },
        //搜索公司列表
        serviceFeeLists() {
            console.log(_this.search_data);
            _this
                .$post('/service_fee/serviceFeeLists', { page: 1, limit: 10 }, _this.search_rules)
                .then((res) => {
                    _this.total_money = res.data.total_money;
                    _this.city_date = res.data.city_date;
                    _this.status = res.data.status.alias;
                    _this.amount = res.data.amount;
                    _this.used_amount = res.data.used_amount;
                    _this.total_money_annualFee = res.data.desc;
                    _this.alert_num = res.data.alert_num || '0';
                    _this.is_alert_month = res.data.is_alert_month;
                })
                .catch((err) => {});
        },

        // 充值
        rechargeBtn() {
            _this.recharge_isShow = !_this.recharge_isShow;
        },
        // 子组件自定义事件
        onSubmit() {
            _this.serviceFeeLists(); //获取账户信息
            _this.searchServiceFeeLogLists(); // 列表
        },

        // 全选或多选
        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].fee_count_log_code);
            }
            _this.search_data.fee_count_log_code_array = datalist;
        },

        // 查询时间
        timeChange(val) {
            // console.log(val);

            if (val != null) {
                _this.search_data.fixed_time = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.fixed_time = '';
            }
        },

        // 搜索
        searchServiceFeeLogLists() {
            _this.search_data.page = 1;

            _this.serviceFeeLogLists();
        },

        //搜索公司列表 导出也是这个接口
        serviceFeeLogLists() {
            // console.log(_this.search_data);
            _this
                .$post('/service_fee/serviceFeeLogLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.result_data = res.count;
                    _this.tableData = res.count.result;
                })
                .catch((err) => {});
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.serviceFeeLogLists(); //解决勾选数据后翻页无数据问题
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.serviceFeeLogLists(); //解决勾选数据后翻页无数据问题
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.serviceFeeLogLists(); //解决勾选数据后翻页无数据问题
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

        // 导出
        toExport() {
            console.log(1);
            _this.search_data.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            console.log(2);
            _this
                .$post('/service_fee/serviceFeeLogLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    console.log(3);
                    _this.progress_show = true;

                    // console.log(_this.progress_show);

                    if (this.$route.path == '/serviceFeeLists') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.count.result.length; i++) {
                            _this.excelData.push({
                                city: res.count.result[i].city.name,
                                billno: res.count.result[i].billno,
                                time: res.count.result[i].time.YmdHis,
                                mode: res.count.result[i].mode.alias,
                                amount: res.count.result[i].amount,
                                description: res.count.result[i].description
                            });
                        }

                        if (res.count.page * res.count.limit < res.count.count) {
                            _this.search_data.page = res.count.page + 1;

                            _this.progress_data = Math.floor(((res.count.page * res.count.limit) / res.count.count) * 100);

                            _this.getExcelData();
                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;
                        }
                    } else {
                        _this.progress_show = false;
                        _this.progress_data = 0;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['城市', '订单编号', '时间', '模式', '金额', '说明'];
            const filterVal = ['city', 'billno', 'time', 'mode', 'amount', 'description'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '城市服务费流水');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        }
    }
};
</script>
<style>
.card-wrap .el-card__body{
    padding: 20px 0 0!important;

}
</style>
<style scoped>
.card-wrap {
    display: flex;
    justify-content: space-between;
}

.card-wrap .title-top{
    padding: 0 27px;
    display: flex;
    justify-content: space-between;
}
.card-wrap .title-top h4{
    font-size: 16px;
    color: #121419;
}

.card-wrap .title-top p{
    font-size: 14px;
    color: #121419;
}

.card-wrap .title-top p span{
    color: red;
}
.card-wrap .title-top p span.green{
    color: #05c0ab;
}
.card-wrap .main{
    padding-right: 27px;
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    align-items: end;
}
.card-wrap .main p{
    font-size: 80px;
    color: #121419;
    font-weight: 400;
}
.card-wrap .main .btn,
.card-wrap .bottom .btn{
    width: 83px;
    line-height: 44px;
    background: #21A7EA;
    border-radius: 2px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
}
.card-wrap .bottom .btn.disabled{
    background: #eee;
}
.card-wrap .bottom{
    margin-top: 30px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 27px;
    background: #FFFFFF;
}
.text-annualFee {
    margin: 0 auto;
    color: red;
    font-size: 14px;
    font-weight: 700;
    text-align: left;
    margin-top: 20px;
    padding: 0 27px;
}
.text-box {
    display: flex;
    width: 500px;
    margin: 10px auto;
}
.text-box span {
    display: block;
    width: 200px;
    height: 31.6px;
    line-height: 31.6px;
    text-align: right;
}
.text-box > p {
    width: 300px;
    height: 31.6px;
    line-height: 31.6px;
    margin-left: 10px;
}

.text {
    font-size: 16px !important;
    font-weight: 400 !important;
    color: #ff7606 !important;
}
.text.flex {
    display: flex;
    justify-content: center;
}
.text > span {
    width: auto;
}
h3 {
    font-size: 24px;
    margin-bottom: 20px;
}
.left .item {
    display: flex;
    margin: 10px auto;
}
.left .item .title,
.left .item .item-text {
    font-size: 16px;
}
h4 {
    font-size: 20px;
    margin-bottom: 10px;
}
.text-box .text p {
    color: #05c0ab;
    height: 31.6px;
    line-height: 31.6px;
}
.text-box .text .total-color {
    color: red;
    height: 31.6px;
    line-height: 31.6px;
}
</style>
